import type { ColDef } from 'ag-grid-community';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { Button, Modal, message, Layout } from 'antd';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { FilingProps, FetchHistoryResponse, FetchHistoryResult, FilingHistoryData } from '../constant';
import { FectchFilingHistory } from "../api/FilingHistory";
import SendMailButtonComponent from '../components/SendMailButtonComponent'
import { ResendConfirm } from '../api/resendconfirm';
import { DownloadExcelHistory } from '../api/excelhistory';
import { FileExcelOutlined } from '@ant-design/icons';
import CustomLoadingOverlay from "../components/CustomLoadingOverlay";

import {
    AllCommunityModule,
    CheckboxEditorModule,
    ClientSideRowModelModule,
    ModuleRegistry,
    themeQuartz,
    ValidationModule
} from "ag-grid-community";
import moment from 'moment';

ModuleRegistry.registerModules([AllCommunityModule, CheckboxEditorModule, ClientSideRowModelModule, ValidationModule]);

const HeaderStyle: React.CSSProperties = {
    height: '50px',
};

const invoiceModalstyle: React.CSSProperties = {
    minHeight: '100px',
    maxHeight: '600px',
    overflowY: 'auto',
};

const isFilingHistoryResponse = (result: FetchHistoryResult): result is FetchHistoryResponse => {
    return result.success === true;
}

const FilingHistory: React.FC<FilingProps> = ({ user, isSelected }) => {

    const [loading, setLoading] = useState(false)
    const [rowData, setRowData] = useState<FilingHistoryData[]>([]);
    const [isinvoiceModal, setInvoiceModal] = useState(false);
    const [selectedinvoice, setSelectedinvoice] = useState<string>("")
    const [historyList, setHistoryList] = useState<FilingHistoryData[]>([]);
    const listRef = useRef(historyList);

    const [colDefs, setColDefs] = useState<ColDef[]>([
        {
            headerClass: 'mail-header',
            headerName: "",
            field: "mail",
            editable: false,
            width: 30,
            cellRenderer: (params: any) => (
                <SendMailButtonComponent
                    api={params.api}
                    node={params.node}
                    onEmailButton={onSendMail}
                />
            ),
        },
        { headerName: 'Seq ID', field: "seqID", width: 120, resizable: true },
        { headerName: 'E-DTR?', field: "edtr", width: 70, resizable: true },
        {
            headerName: 'Date', field: "postDate", width: 120, resizable: true,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        { headerName: 'Filename', field: "fileName", width: 250, resizable: true },
        { headerName: 'Total Lines', field: "totalLines", width: 120, resizable: true, cellStyle: { textAlign: "right" } },
        //{ headerName:'Lines Accepted', field: "linesAccepted", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        //{ headerName:'Lines Rejected', field: "linesRejected", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        {
            headerName: 'Total Premium', field: "totalPremium", width: 120, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        // { headerName:'Premium Accepted', field: "premiumAccepted", width: 120, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        // { headerName:'Premium Rejected', field: "premiumRejected", width: 90, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        {
            headerName: 'Total Policy Fees', field: "totalPolicyFees", width: 120, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        // { headerName:'Policy Fees Accepted', field: "policyFeesAccepted", width: 120, resizable: true, cellStyle: { textAlign: "right" } ,
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        // { headerName:'Policy Fees Rejected', field: "policyFeesRejected", width: 100, resizable: true, editable: false, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        {
            headerName: 'Total Tax', field: "totalTax", width: 120, resizable: true, editable: false, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        // { headerName: 'Tax Accepted', field: 'taxAccepted', width: 120,  editable: false, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        // { headerName: 'Tax Rejected', field: 'taxRejected', width: 100,  editable: false, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        {
            headerName: 'Total Stamping Fee', field: 'totalStFee', width: 120, editable: false, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        // { headerName: 'Stamping Fee Accepted', field: 'stFeeAccepted', width: 120,  editable: false, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        // { headerName: 'Stamping Fee Rejected', field: 'stFeeRejected', width: 100,  editable: false, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         return parseFloat(params.value).toFixed(2);
        //     },
        // },
        {
            headerName: 'Penalty', field: 'penalty', width: 120, editable: false, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        //{ headerName: 'Response', field: 'invoice', width: 400,  editable: false, cellStyle: { textAlign: "right" }},
    ]);

    useEffect(() => {
        listRef.current = historyList;
    }, [historyList]);

    useEffect(() => {
        if (!isSelected) {
            return;
        }
        console.log("user.licenseNumber changed: ", user.licenseNumber)
        setLoading(true)

        FectchFilingHistory(user.licenseNumber)
            .then((fetchHistoryResult) => {

                if (fetchHistoryResult.success) {
                    //message.success({ content: 'Successfully loaded Filing History', key: 'historyStatus', duration: 2  });
                    if (isFilingHistoryResponse(fetchHistoryResult)) {
                        setHistoryList(fetchHistoryResult.filing)
                        setRowData(fetchHistoryResult.filing)
                    }
                }
                else {
                    message.error({ content: 'Failed to load the filing history', key: 'historyStatus', duration: 2 });
                    if ("errorMsg" in fetchHistoryResult) {
                        message.error(fetchHistoryResult.errorMsg)
                    }
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error.message);
                return
            })
            .finally(() => {
                setLoading(false)
            });
    }, [user.licenseNumber]);

    useEffect(() => {

        // setLoading(true)

        // FectchFilingHistory(user.licenseNumber)
        //     .then((fetchHistoryResult) => {

        //         if (fetchHistoryResult.success) {
        //             //message.success({ content: 'Successfully loaded Filing History', key: 'historyStatus', duration: 2  });
        //             if (isFilingHistoryResponse(fetchHistoryResult)) {
        //                 setHistoryList(fetchHistoryResult.filing)
        //                 setRowData(fetchHistoryResult.filing)
        //             }
        //         }
        //         else {
        //             message.error({ content: 'Failed to load the filing history', key: 'historyStatus', duration: 2 });
        //             if ("errorMsg" in fetchHistoryResult) {
        //                 message.error(fetchHistoryResult.errorMsg)
        //             }
        //         }
        //     })
        //     .catch((error) => {
        //         console.error("An error occurred:", error.message);
        //         return
        //     })
        //     .finally(() => {
        //         setLoading(false)
        //     });
    }, []);


    const onSendMail = (rowIndex: number) => {
        console.log(`seqID = ${listRef.current[rowIndex].seqID}`)
        message.loading({ content: 'resend report...', key: 'resendconfirm', duration: 0 });
        ResendConfirm(listRef.current[rowIndex].seqID, user.licenseNumber)
            .then((response) => {
                if (response.success) {
                    message.success({ content: response.errorMsg, key: 'resendconfirm', duration: 2 })
                }
                else {
                    if ("errorMsg" in response) {
                        message.error({ content: response.errorMsg, key: 'resendconfirm', duration: 2 })
                    }
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error.message);
                return
            });
    }

    const hideInvoiceModal = () => {
        setInvoiceModal(false);
    }
    const defaultColDef = useMemo<ColDef>(() => {
        return {
            headerClass: 'custom-header',
            sortable: false,
        };
    }, []);

    const myTheme = themeQuartz
        .withParams({
            headerColumnBorder: { color: 'gray' },
            headerColumnBorderHeight: '90%',
        });

    const onCellValueChanged = (params: any) => {
        params.node.setDataValue("validate", isValidate(params.data) === true ? "" : "!")
    };
    const onCellDoubleClicked = (params: any) => {
        if (params.colDef.field === "carriers") {

        }
    };

    const onRowDoubleClicked = (event: { data: FilingHistoryData }) => {
        console.log(`RowDoubleClick = ${event.data.seqID}`)
        //setSelectedinvoice(event.data.invoice)
        //showInvoiceModal()
    };

    const isValidate = (data: any) => {
        return true
    }

    const onClickExcelBtn = () => {
        DownloadExcelHistory(user.licenseNumber)
            .then((response) => {
                if (response.success) {
                    message.success(response.errorMsg)
                }
                else {
                    message.error(response.errorMsg)
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error.message);
                return
            });
    }

    return (
        <div style={{ height: '100%' }} className='text-style'>
            <div className="flex justify-between items-center bg-gray-100" style={HeaderStyle}>
                <div className='flex flex-row ml-10 text-xs'>
                    <div><span>Click the envelope on the far left to get an email containing the invoice, detail and E-DTR (if applicable) for a given submission.  </span></div>
                </div>
                <Button
                    variant="outlined"
                    type='primary'
                    onClick={onClickExcelBtn}
                    icon={<FileExcelOutlined className='icon-style' />}
                    className='ml-0.5, mr-20 button-style'>
                    Save to Excel
                </Button>
            </div>
            <div className="ag-theme-alpine  tab-container">
                <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    theme={myTheme}
                    defaultColDef={defaultColDef}
                    headerHeight={35}
                    rowHeight={25}
                    onCellValueChanged={onCellValueChanged}
                    onCellDoubleClicked={onCellDoubleClicked}
                    onRowDoubleClicked={onRowDoubleClicked}
                    loading={loading}
                    loadingOverlayComponent={CustomLoadingOverlay}
                    loadingOverlayComponentParams={{ message: 'Loading...' }}

                />
            </div>

            <Modal
                title={
                    <div className='text-style' style={{ textAlign: "center", fontWeight: "bold" }}>
                        Invoice
                    </div>
                }
                className='text-style'
                open={isinvoiceModal}
                width={1000}
                height={900}
                onCancel={hideInvoiceModal}
                footer={null}
            >
                <div style={{ whiteSpace: 'pre-wrap', fontSize: '9px', ...invoiceModalstyle }}>
                    {selectedinvoice}
                </div>
            </Modal>
        </div>
    )
}

export default FilingHistory;